import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

@Pipe({
    name: 'formStatus',
    standalone: false
})
export class FormStatusPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {
  }

  public transform(txt): string {
    if (txt === 'upload-error') {
      return 'Upload Error';
    } else if (txt === 'accepted') {
      return 'Published';
    } else if (txt === 'patient-nullified') {
      return 'Patient Nullified';
    } else if (txt === 'rejected') {
      return 'Rejected';
    } else if (txt === 'assigned') {
      return 'Assigned';
    } else if (txt === 'reject') {
      return 'Rejected';
    } else if (txt === 'patient-upload') {
      return 'Patient Upload';
    } else if (txt === 'batch_split') {
      return 'Batch Split';
    } else if (txt === 'split') {
      return 'Split';
    } else if (txt === 'batch_processed') {
      return  'Batch Processed';
    } else if (txt === 'uploaded') {
      return 'Uploaded';
    } else if (txt === 'publish') {
      return 'Published';
    } else if (txt === 'draft') {
      return 'Draft';
    } else if (txt === 'repeat-upload') {
      return  'Repeat Upload';
    } else if (txt === 'daily-drop') {
      return  'Daily Drop';
    } else if (txt === 'archive') {
      return 'Archived';
    }
    return 'Unknown Form Status';
  }

}
